import { useEffect, useState } from "react";
import { useTranslation } from "@/shared/i18n/LocaleProvider";

export function useThinkingMessage(isActive: boolean): string {
  const { t } = useTranslation();
  const phrases = t("advice.thinking.phrases", {
    returnObjects: true,
    defaultValue: [],
  }) as readonly string[];

  const [message, setMessage] = useState(phrases[0] ?? "");

  useEffect(() => {
    if (!isActive) return;
    const shuffled = [...phrases].sort(() => Math.random() - 0.5);
    let i = 0;
    const first = setTimeout(() => setMessage(shuffled[0]), 0);
    const id = setInterval(() => {
      i = (i + 1) % shuffled.length;
      setMessage(shuffled[i]);
    }, ROTATE_MS);
    return () => {
      clearTimeout(first);
      clearInterval(id);
    };
  }, [isActive, phrases]);

  return message;
}

const ROTATE_MS = 3000;
